"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_TYPES = void 0;
var MEDIA_TYPES;
(function (MEDIA_TYPES) {
    MEDIA_TYPES["SECURE_VIDEO"] = "secure_video";
    MEDIA_TYPES["PICTURE"] = "picture";
    MEDIA_TYPES["VIDEO"] = "video";
})(MEDIA_TYPES = exports.MEDIA_TYPES || (exports.MEDIA_TYPES = {}));
//# sourceMappingURL=media-types.js.map